import React, { useRef, ChangeEvent, useEffect, useState } from 'react';
import './index.less'
const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'

interface Props {
  useInDetail: boolean
  stationLabelList: any[]
  className?: string
  disabled?: boolean
}

const StationTag = ({
  useInDetail,
  stationLabelList,
  className = '',
  disabled = false
}: Props) => {
  // (新)小鹏自营、小鹏自营、优选合作这几个标签在详情页不展示，前端过滤掉
  const specicalLabelCodes = ['newXpSelfOperate', 'xpSelfOperate', 'preferredPartnership']

  // 若是在详情页展示，需要过滤掉specicalLabelCodes；若是在列表页展示，只展示前5个
  const renderLabelList = useInDetail ?
    (stationLabelList?.filter(item => !specicalLabelCodes.includes(item.labelCode)) || [])
    : (stationLabelList?.slice(0, 5) || [])

  const Tag = ({ tagItem }) => {
    const { labelCode, labelName } = tagItem

    // canUseFreeRight-免费权益的标签样式为金色
    const tagMap = {
      'newXpSelfOperate':
        <div className='station-tag-prefix'>
          <img
            className='prefix-icon'
            alt=''
            src={
              disabled ? `${CHARGE_CDN}/station/new-self-operation-disabled.png`
                : `${CHARGE_CDN}/common/new-self-operation.png`
            }
          />
          <div className='station-tag-common self'>{labelName}</div>
        </div>
      ,
      'xpSelfOperate':
        <div className='station-tag-prefix'>
          <img
            className='prefix-icon'
            alt=''
            src={
              disabled ? `${CHARGE_CDN}/station/xp-self-operation-disabled.png`
                : `${CHARGE_CDN}/common/xp-self-operation.png`
            }
          />
          <div className='station-tag-common self'>{labelName}</div>
        </div>
      ,
      'preferredPartnership':
        <div className='station-tag-prefix'>
          <img
            className='prefix-icon'
            alt=''
            src={
              disabled ? `${CHARGE_CDN}/station/preferred-partner-disabled.png`
                : `${CHARGE_CDN}/common/preferred-partner.png`
            }
          />
          <div className='station-tag-common preferred'>{labelName}</div>
        </div>
      ,
      'canUseFreeRight':
        <div className='station-tag-common gold'>{labelName}</div>

    }

    return tagMap[labelCode] || <div className='station-tag-common'>{labelName}</div>
  }

  return (
    <div className={`station-tag-wrap ${disabled ? 'disabled' : ''} ${className}`}>
      {
        renderLabelList?.length > 0 && renderLabelList.map((item, index) => (
          <Tag tagItem={item} key={index + item.labelCode} />
        ))
      }
    </div>
  )
}

export default StationTag